export const WEB_ADMIN_AUTH_ERROR_EVENT = 'webadmin:auth-error';
export const WEB_ADMIN_EXTERNAL_AUTH_BOUNDARY_EVENT = 'webadmin:external-auth-boundary';

export type WebAdminAuthBoundaryKind = 'transition' | 'login' | 'logout';

export type WebAdminAuthErrorEventDetail = {
  statusCode: number;
  error: string;
  requestId?: string;
};

export function dispatchWebAdminAuthError(detail: WebAdminAuthErrorEventDetail): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<WebAdminAuthErrorEventDetail>(WEB_ADMIN_AUTH_ERROR_EVENT, { detail }),
  );
}

export function onWebAdminAuthError(
  handler: (detail: WebAdminAuthErrorEventDetail) => void,
): () => void {
  if (typeof window === 'undefined') return () => {};
  const listener = (event: Event) => {
    const custom = event as CustomEvent<WebAdminAuthErrorEventDetail>;
    handler(custom.detail);
  };
  window.addEventListener(WEB_ADMIN_AUTH_ERROR_EVENT, listener as EventListener);
  return () => window.removeEventListener(WEB_ADMIN_AUTH_ERROR_EVENT, listener as EventListener);
}

export function dispatchExternalWebAdminAuthBoundary(kind: WebAdminAuthBoundaryKind): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<WebAdminAuthBoundaryKind>(WEB_ADMIN_EXTERNAL_AUTH_BOUNDARY_EVENT, {
      detail: kind,
    }),
  );
}

export function onExternalWebAdminAuthBoundary(
  handler: (kind: WebAdminAuthBoundaryKind) => void,
): () => void {
  if (typeof window === 'undefined') return () => {};
  const listener = (event: Event) => {
    const custom = event as CustomEvent<WebAdminAuthBoundaryKind>;
    handler(custom.detail);
  };
  window.addEventListener(WEB_ADMIN_EXTERNAL_AUTH_BOUNDARY_EVENT, listener as EventListener);
  return () =>
    window.removeEventListener(WEB_ADMIN_EXTERNAL_AUTH_BOUNDARY_EVENT, listener as EventListener);
}
